import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Görünür breadcrumb; JSON-LD BreadcrumbList ile aynı sırayı kullanın.
 */
export function PageBreadcrumb({ items, className = '' }) {
  if (!items?.length) return null;

  return (
    <nav aria-label="Breadcrumb" className={`text-sm text-muted-foreground mb-3 ${className}`}>
      <ol className="flex flex-wrap items-center gap-1 list-none p-0 m-0">
        {items.map((it, i) => (
          <li key={`${it.label}-${i}`} className="flex items-center gap-1 min-w-0">
            {i > 0 && <ChevronRight className="w-3 h-3 shrink-0 opacity-70" aria-hidden />}
            {it.to ? (
              <Link to={it.to} className="hover:text-primary truncate max-w-[14rem]">
                {it.label}
              </Link>
            ) : (
              <span className="text-foreground font-medium truncate max-w-[16rem]">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
